var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open_menu)?_c('div',{staticClass:"menu-list",style:(_vm.custom_style),attrs:{"id":"menu-container"}},_vm._l((_vm.menu_items),function(menu_item,index){return _c('div',{key:index,class:[
        'menu-item',
        { active: _vm.selected_item === menu_item ? true : false },
      ],on:{"click":function($event){$event.stopPropagation();return _vm.select_item(menu_item)}}},[_vm._v(" "+_vm._s(menu_item)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }